import axiosInstance from "./global-instance";
import createScopedApi from "./createScopedApi";
import { b2cBffApiUrl } from "../constants/url-constants";

const BASE_API_URL = `${b2cBffApiUrl()}/api`;

export default createScopedApi(BASE_API_URL, axiosInstance);
